import { styled, FormikButtonSubmit, Skeleton as UiSkeleton, Typography, styledForMobile } from "@l2r-front/l2r-ui"

import { RoadworkTagsList } from "../../containers/RoadworkTagsList"

import { TaskImpactBadge as L2RTaskImpactBadge } from "../TaskImpactBadge"

export const RoadworkDetailWrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(isMobile ? 5 : 8, isMobile ? 5 : 8, 5, isMobile ? 5 : 8),
    width: "100%",
}))

export const YearWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
}))

export const TechniqueWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}))

export const InfoContainer = styled("div")((({ theme }) => ({
    alignItems: "flex-start",
    color: theme.palette["warning"].main,
    border: "1px solid",
    borderRadius: theme.spacing(3),
    display: "flex",
    padding: theme.spacing(2, 3),
})))

export const InfoText = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(3),
    color: theme.palette["_components/alert/warning/color"].main,
}))


export const DoneTechniqueWrapper = styled("div")(() => ({
    display: "flex",
    flexDirection: "row",
}))

export const Wrapper = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}))

export const TaskImpactBadge = styled(L2RTaskImpactBadge)({
    height: "fit-content",
})

export const DoneInfoContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.spacing(3),
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "top",
    backgroundColor: theme.palette["action/disabledBackground"].main,
    padding: theme.spacing(5, 3),
}))

export const ButtonWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(8),
    justifyContent: "flex-end",
    marginTop: theme.spacing(5),
}))

export const SubmitButton = styled(FormikButtonSubmit)(() => ({
    width: "fit-content",
}))

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
    textAlign: "center",
}))

export const RoadworkDetailSkeleton = styled(UiSkeleton)({
    transform: "scale(1)",
    height: "100%",
    width: "100%",
    flex: 1,
})

export const Year = styled(Typography)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
}))

export const RoadworkDoneWrapper = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
})

export const DoneRoadworkTagsList = styled(RoadworkTagsList)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}))